import { render, staticRenderFns } from "./DataDashboard.vue?vue&type=template&id=8e4ef008&scoped=true"
import script from "./DataDashboard.vue?vue&type=script&lang=js"
export * from "./DataDashboard.vue?vue&type=script&lang=js"
import style0 from "./DataDashboard.vue?vue&type=style&index=0&id=8e4ef008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4ef008",
  null
  
)

export default component.exports